import { api } from '../util/mock/index'
import { getGuestIdFromRouter } from '../util/selectors'
import { GUEST_REGEX } from '../util/constants'
export const CHECK_GUEST_EXISTS = 'guest/CHECK_GUEST_EXISTS'
export const GUEST_EXISTS_TRUE = 'guest/GUEST_EXISTS_TRUE'
export const GUEST_EXISTS_FALSE = 'guest/GUEST_EXISTS_FALSE'
export const UPDATE_PIN = 'guest/UPDATE_PIN'
export const UPDATE_GUEST_ID = 'guest/UPDATE_GUEST_ID'
export const CHECK_GUEST_PIN = 'guest/CHECK_GUEST_PIN'
export const GUEST_PIN_INVALID = 'guest/GUEST_PIN_INVALID'
export const GUEST_PIN_VALID = 'guest/GUEST_PIN_VALID'
export const FORM_TOGGLE_ACCEPT_TERMS = 'guest/FORM_TOGGLE_ACCEPT_TERMS'
export const SUBMIT_FORM = 'guest/SUBMIT_FORM'
export const SUBMIT_FORM_SUCCESS = 'guest/SUBMIT_FORM_SUCCESS'
export const RESET_FORM = 'guest/RESET_FORM'
const initialState = {
  checkedGuestExists: false,
  guest_id: "",
  checkingGuestExists: false,
  guestExists: false,
  checkedGuestPin: false,
  pin: "",
  checkingGuestPin: false,
  guestPinIsValid: false,
  guest_name: "",
  guestFormSubmitted: false,
  submittingGuestForm: false,
  form: {
    termsAccepted: false
  },
  gateCode: ""
}
export default (guest = initialState, action) => {
  switch (action.type) {
    case CHECK_GUEST_EXISTS:
      return { ...guest, checkingGuestExists: true }
    case GUEST_EXISTS_TRUE:
      return { ...guest, checkingGuestExists: false, guestExists: true }
    case GUEST_EXISTS_FALSE:
      return { ...guest, checkingGuestExists: false, guestExists: false }
    case UPDATE_PIN:
      return { ...guest, pin: action.pin }
    case UPDATE_GUEST_ID:
      return { ...guest, guest_id: action.guest_id }
    case CHECK_GUEST_PIN:
      return { ...guest, checkingGuestPin: true }
    case GUEST_PIN_INVALID:
      return { ...guest, checkingGuestPin: false, checkedGuestPin: true, guestPinIsValid: false }
    case GUEST_PIN_VALID:
      return { ...guest, checkingGuestPin: false, checkedGuestPin: true, guestPinIsValid: true, guest_name: action.guest_name }
    case FORM_TOGGLE_ACCEPT_TERMS:
      const termsAccepted = !guest.form.termsAccepted;
      return { ...guest, form: { termsAccepted } }
    case SUBMIT_FORM:
      return { ...guest, submittingGuestForm: true }
    case SUBMIT_FORM_SUCCESS:
      return { ...guest, submittingGuestForm: false, guestFormSubmitted: true, gateCode: action.gateCode }
    case RESET_FORM:
      return { ...initialState }
    default:
      return { ...guest }
  }
}

export function checkGuestExists(e) {
  return (dispatch, getState) => {
    const { guest_id } = getState().guest;
    dispatch({ type: CHECK_GUEST_EXISTS });
    api.checkGuestExists(guest_id, function (err, guestExists) {
      if (err) throw new Error("Unhandled checkGuestExists err");
      if (!guestExists) {
        dispatch({ type: GUEST_EXISTS_FALSE })
      } else {
        dispatch({ type: GUEST_EXISTS_TRUE, guest_id })
      }
    });
  }
}
export function checkGuestPin(e) {
  return (dispatch, getState) => {
    const { guest_id, pin } = getState().guest
    dispatch({ type: CHECK_GUEST_PIN });
    api.checkGuestPin(guest_id, pin, function (err, { guestPinIsValid, guest_name }) {
      if (err) throw new Error("Unhandled checkGuestPin err");
      if (!guestPinIsValid) {
        dispatch({ type: GUEST_PIN_INVALID });
      } else {
        dispatch({ type: GUEST_PIN_VALID, guest_name })
      }
    })
  }
}

export function toggleAcceptTerms(e) {
  return (dispatch) => {
    dispatch({ type: FORM_TOGGLE_ACCEPT_TERMS });
  }
}
export function submitGuestForm(e) {
  return (dispatch, getState) => {
    const { guest_id, form } = getState().guest;
    dispatch({ type: SUBMIT_FORM });
    api.submitGuestForm(guest_id, form, function (err, gateCode) {
      if (err) throw new Error("Unhandled submitGuestForm err");
      dispatch({ type: SUBMIT_FORM_SUCCESS, gateCode })
    })
  }
}
export function updatePin(e) {
  return (dispatch) => {
    dispatch({ type: UPDATE_PIN, pin: e.target.value })
  }
}
export const updateGuestId = (e) => {
  return dispatch => {
    dispatch({ type: UPDATE_GUEST_ID, guest_id: e.target.value })
  }
}
export const updateGuestIdFromPath = () => {
  return (dispatch, getState) => {
    const guest_id = getGuestIdFromRouter(getState().router)
    if (guest_id) {
      dispatch({ type: UPDATE_GUEST_ID, guest_id });
      if (guest_id.match(GUEST_REGEX)) {
        dispatch({ type: CHECK_GUEST_EXISTS })
      }
    }
  }
}
export const reset = (e) => {
  return dispatch => {
    dispatch({ type: RESET_FORM })
  }
}


// WEBPACK FOOTER //
// ./src/reducers/guest.js